import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "./motion";
import { useLang } from "@/i18n/LanguageContext";

const SKYLINE = "https://images.unsplash.com/photo-1666843527155-14ec5f016802?q=80&w=1200&auto=format&fit=crop";

export const Founder = () => {
  const { t } = useLang();
  const f = t.founder;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="founder" ref={ref} className="py-24 md:py-40 bg-white">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-start">
        <Reveal className="md:col-span-6 order-2 md:order-1">
          <div className="vw-eyebrow text-vw-green mb-8">{f.eyebrow}</div>
          <blockquote className="font-serif text-3xl md:text-4xl leading-[1.15] tracking-tight text-vw-ink text-balance mb-10">
            {f.qPre}
            <span className="italic font-light text-vw-green">{f.qEm}</span>
            {f.qClose}
          </blockquote>
          <div className="mb-6">
            <div className="font-serif text-2xl text-vw-ink">Aniiket Pawar</div>
            <div className="vw-eyebrow text-vw-ink2 mt-1">{f.role}</div>
          </div>
          <div className="space-y-5 max-w-2xl">
            {f.bio.map((para, i) => (
              <p key={i} className="text-base md:text-lg text-vw-ink2 leading-relaxed">
                {para}
              </p>
            ))}
          </div>
        </Reveal>

        <div className="md:col-span-6 order-1 md:order-2 md:sticky md:top-28">
          <div className="relative overflow-hidden aspect-[3/4] bg-vw-bg3">
            <motion.img
              style={{ y }}
              src={SKYLINE}
              alt="Mumbai skyline at night"
              className="h-[110%] w-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
            <div className="absolute bottom-4 left-4 bg-vw-green/90 backdrop-blur px-3 py-2">
              <span className="font-mono text-[0.65rem] text-white tracking-wider">{f.city}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
